import React from 'react'
import styled from 'styled-components'
import { Flex, Text /* TelegramIcon, TwitterIcon */ } from '@pancakeswap/uikit'
import { alpha } from '@mui/material'
import {
  AML_KYC_LINK,
  API_DOCUMENT_LINK,
  COOKIE_POLICY_LINK,
  FAQ_LINK,
  PRIVACY_POLICY_LINK,
  USER_AGREEMENT_LINK,
} from 'config/constants/links'
// import { useTranslation } from 'contexts/Localization'
// import { FlexGap } from 'components/Layout/Flex'
// import NetworkSwitch from './NetworkSwitch'
// import useTheme from 'hooks/useTheme'

const Wrapper = styled.div`
  color: ${({ theme }) => theme.colors.textSubtle};
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: flex-end;

  a:hover {
    color: ${({ theme }) => theme.colors.text};
  }
  .footer-link {
    color: ${({ theme }) => theme.colors.textSubtle};
    display: block;
    padding: 12px 0;
    font-family: 'Urbanist', serif;
    font-weight: 400;
    font-size: 12px;

    @media (max-width: 575px) {
      font-size: 10px;
      padding: 8px 0;
    }
  }
  .footer-logo {
    font-size: 37px;
    font-family: 'Urbanist', serif;
    font-weight: 100;
    color: #fff;
  }
  .bottom-text {
    font-size: 10px;
    font-family: 'Urbanist', serif;
    font-weight: 500;
    a {
      color: ${({ theme }) => theme.colors.textSubtle};
    }
  }
`

const Divider = styled.div`
  border-top: 1px solid #fff;
  margin: 0 25px;
  opacity: 0.5;

  ${({ theme }) => theme.mediaQueries.md} {
    justify-content: space-between;
    margin: 0;
    border-top-color: ${({ theme }) => alpha(theme.colors.text, 0.15)};
  }
`

// const BubbleWrapper = styled(Flex)`
//   svg {
//     fill: ${({ theme }) => theme.colors.textSubtle};
//     transition: background-color 0.2s, opacity 0.2s;
//   }
//   &:hover {
//     svg {
//       opacity: 0.65;
//     }
//   }
//   &:active {
//     svg {
//       opacity: 0.85;
//     }
//   }
// `

type FooterVariant = 'default' | 'side'

const footerLinksDesktop: any = [
  [
    {
      label: 'FAQ',
      link: FAQ_LINK,
    },
    {
      label: 'User Aggrement',
      link: USER_AGREEMENT_LINK,
    },
    {
      label: 'AML and KYC Policy',
      link: AML_KYC_LINK,
    },
    {
      label: 'Privacy Policy',
      link: PRIVACY_POLICY_LINK,
    },
    {
      label: 'API Documentation',
      link: API_DOCUMENT_LINK,
    },
    {
      label: 'Cookie Policy',
      link: COOKIE_POLICY_LINK,
    },
  ],
]

// const footerLinksMobile: any = [
//   {
//     label: 'Exchange',
//     link: 'https://my.ncx.cx/',
//   },
//   {
//     label: 'Trade',
//     link: 'https://trade.ncx.cx',
//   },
//   {
//     label: 'DEX',
//     link: 'https://bsc.ncx.cx/swap',
//   },
//   {
//     label: 'Markets',
//     link: 'https://ncx.cx',
//   },
//   {
//     label: 'Connect',
//     link: 'https://ncx.cx/blog',
//   },
//   {
//     label: 'Documentation',
//     link: 'https://docs.ncx.cx/',
//   },
// ]

const Footer: React.FC<{ variant?: FooterVariant }> = () => {
  // const { t } = useTranslation()
  // const isSide = variant === 'side'
  // const { theme } = useTheme()
  // eslint-disable-next-line no-constant-condition
  return true ? null : (
    <Wrapper>
      <div className="hide-mobile" />
      <div className="hide-mobile" style={{ width: '100%', maxWidth: 1440 }}>
        <Divider />
        <Flex justifyContent="space-between" pb="18px">
          <Flex>
            <Text className="footer-link" fontSize="12px">
              NCX Digital Exchange LLC &copy; 2022-2023
            </Text>
          </Flex>
          {footerLinksDesktop.map((col) => (
            <Flex key={`footer-cols${col[0].label}`} flex={1} justifyContent="flex-end" style={{ gap: 20 }}>
              {col.map((item) => (
                <a
                  key={`col-items${item.label}`}
                  className="footer-link"
                  target={item.target || '_blank'}
                  href={item.link}
                >
                  {item.label}
                </a>
              ))}
            </Flex>
          ))}
        </Flex>
      </div>

      <div className="hide-desktop">
        {/* <Divider />
        <Flex justifyContent="center" flexDirection="column" alignItems="center">
          <Flex>
            <Text className="footer-link" fontSize="12px">
              NCX Digital Exchange LLC &copy; 2022-2023
            </Text>
          </Flex>
          <Flex flex={1} justifyContent="flex-end" style={{ gap: 20 }}>
            {footerLinksMobile.map((item) => (
              <a className="footer-link" target={item.target || '_blank'} href={item.link}>
                {item.label}
              </a>
            ))}
          </Flex>
        </Flex>
        <Flex justifyContent="center" alignItems="center" mb="80px" mt="20px" style={{ gap: 20 }}>
          <a target="_blank" rel="noreferrer" href="https://t.me/NCX_CX">
            <TelegramIcon width={25} color={theme.colors.text} />
          </a>
          <a target="_blank" rel="noreferrer" href="https://twitter.com/NCX_CX">
            <TwitterIcon width={25} fillColor={theme.colors.text} />
          </a>
        </Flex> */}
      </div>
    </Wrapper>
  )
}

export default Footer
